// extracted by mini-css-extract-plugin
module.exports = {"rangeInputContainer":"PMVKW___SizeFilter-module__rangeInputContainer","input":"_3-v0R___SizeFilter-module__input","rangeUnit":"_1arI1___SizeFilter-module__rangeUnit"};